function getCP3Env(envKey) {
	if (window?._env_?.hasOwnProperty(envKey)) {
		return window._env_[envKey];
	}
	return process.env[envKey];
}

function checkCP3Env(envKey) {
	return window?._env_?.hasOwnProperty(envKey) || process.env.hasOwnProperty(envKey);
}

export { getCP3Env, checkCP3Env };
